/* eslint-disable no-unused-vars */
import React, { useState, useContext, useEffect } from "react";
import { useNavigate, Navigate } from 'react-router-dom';
import { db } from "../../services/api"
import Context from "../../context/AuthContext";
import AlertMessage from "../../components/AlertMessage";
import "./Register.scss"

const Register = () => { 

const [ open, setOpen ] = useState(false);
const [ firstName, setFirstName ] = useState()
const [ lastName, setLastName ] = useState()
const [ email, setEmail ] = useState()
const [ password, setPassword ] = useState()
const [ adin, setAdin ] = useState()
const [ error, setError ] = useState(null)

const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };
    
    const auth = useContext(Context)
    const navigate = useNavigate()
    
    useEffect( () => {
        async function authUseEffect(){
            if(auth.state.authorized){
                const token = localStorage.getItem("token")
    
                await fetch(`${process.env.REACT_APP_URL}/api/v1/user/verify`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`
                }})
                .then(res => res.json())
                .then((res) => {
                    if(res.success === true){
                        navigate("/")
                    }
                })
            }
        }
        authUseEffect()
    },[auth])
    
    const payload = {
        "first_name": firstName,
        "last_name":lastName,
        "email":email, 
        "password":password,
        "adin":adin
    }
    
    async function handleSubmit(e){
        e.preventDefault()

        await fetch(`${process.env.REACT_APP_URL}/api/v1/user/register`, {
            method: "POST",
            body: JSON.stringify(payload),
            headers: new Headers({
                "Content-Type": "Application/json"
            })
        })
        .then(res => res.json())
        .then(res => {
            if(res.id){
                navigate("/")
            }else{
                setError(res.message)
                setOpen(true)
            }
        })
    }
    
    return (
        <div className="container-register">
            <main className="main-content">
                <img 
                className="main-content__logo" 
                src="image/logo.jpg" 
                alt="logo médico sem fronteira"
                />
                <form onSubmit={handleSubmit}  className="form">
                <input 
                onChange={e => setFirstName(e.target.value)} 
                placeholder="Nome" 
                className="input"></input>
                <input 
                onChange={e => setLastName(e.target.value)} 
                placeholder="Sobrenome" 
                className="input"></input>
                <input 
                type="email"
                onChange={e => setEmail(e.target.value)} 
                placeholder="Email" 
                className="input"></input>
                <input 
                type="password"
                onChange={e => setPassword(e.target.value)}
                placeholder="Password" 
                className="input"></input>
                <input 
                onChange={e => setAdin(e.target.value)}
                placeholder="Adin" 
                className="adin"></input>
                <button type="submit"  className='button'> Registrar  </button>
                <AlertMessage message={error} status={'error'} open={open}  onClick={handleClose} close={handleClose}/>
            </form>
            </main>
            <span className="loggin">Já é cadastrado? <a  href="/">login</a></span>

        </div>
    ) };

export default Register;